var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStoreinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 12v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8m1-6h16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 21v-6h5v6M22 9a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1-5 0l1.586-5.55A2 2 0 0 1 5.509 2H18.49a2 2 0 0 1 1.923 1.45z"
}))));
export default SvgStoreinline;